import script from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchComponent.vue?vue&type=script&setup=true&lang=js"

import "./SearchComponent.vue?vue&type=style&index=0&id=3304322a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3304322a"]])

export default __exports__